<div class="row justify-content-center">
  <div class="col-12 col-lg-10 col-xl-8">
    <div class="header">
      <div class="header-body">
        <div class="row align-items-center">
          <div class="col">

            <!-- Pretitle -->
            <h6 class="header-pretitle">
              Aperçu
            </h6>

            <!-- Title -->
            <h1 class="header-title text-truncate">
              Liste des clients
            </h1>

          </div>
          <div class="col-auto">
            <div class="dropdown">
              <button aria-expanded="false" aria-haspopup="true" class="btn btn-sm btn-primary"
                data-bs-toggle="dropdown"
                id="inviteMember" type="button">
                Ajouter un client
              </button>
              <form aria-labelledby="inviteMember" class="dropdown-menu dropdown-menu-end dropdown-menu-card">
                <div class="card-header">

                  <!-- Title -->
                  <h4 class="card-header-title">
                    Ajouter un client
                  </h4>


                </div>
                <div class="card-header">
                  <div class="row g-0 align-items-center">
                    <div class="col-5">

                      <!-- Label -->
                      <label class="mb-0" for="inviteMemberName">
                        Nom
                      </label>

                    </div>
                    <div class="col">

                      <!-- Input -->
                      <input class="form-control form-control-flush" id="inviteMemberName" placeholder="Full name"
                        type="text">

                    </div>
                  </div> <!-- / .row -->
                </div>
                <div class="card-header">
                  <div class="row g-0 align-items-center">
                    <div class="col-5">

                      <!-- Label -->
                      <label class="mb-0" for="inviteMemberEmail">
                        Adresse électronique
                      </label>

                    </div>
                    <div class="col">

                      <!-- Input -->
                      <input class="form-control form-control-flush" id="inviteMemberEmail"
                        placeholder="jean.tremblay@optitax.ca"
                        type="text">

                    </div>
                  </div> <!-- / .row -->
                </div>
                <div class="card-footer">

                  <!-- Button -->
                  <button class="btn w-100 btn-primary" type="submit">
                    Créer le client
                  </button>

                </div>
              </form>
            </div>
            <!--                        &lt;!&ndash; Buttons &ndash;&gt;-->
            <!--                        <a href="#!" class="btn btn-primary ms-2">-->
            <!--                            Ajouter un client-->
          <!--                        </a>-->

        </div>
      </div> <!-- / .row -->
    </div>
  </div>

  <div class="card"
    id="contactsList">
    <div class="card-header">
      <app-search-table-header [searchTableViewModel]="searchTableViewModel" perPageLabelText="par page"
      searchFieldPlaceholderText="Rechercher un client"></app-search-table-header>
    </div>
    <div [class.visually-hidden]="searchTableViewModel.state === 'LOADING'" class="table-responsive">
      <table class="table table-sm table-hover table-nowrap card-table">
        <thead>
          <tr>
            @for (column of searchTableViewModel.columns; track column) {
              <th>
                <a class="list-sort text-muted" routerLink="">{{ column.text }}</a>
              </th>
            }

            <th></th>
          </tr>
        </thead>
        <tbody class="list fs-base">
          @for (row of searchTableViewModel.rows; track row) {
            <tr>
              <td>
                <a class="item-name text-reset" routerLink="">{{ row.name }}</a>
              </td>
              <td>
                <!-- Text -->
                <span class="item-title">{{ row.role }}</span>
              </td>
              <td>
                <!-- Email -->
                <a [href]="'mailto:' + row.email" class="item-email text-reset">{{ row.email }}</a></td>
                <td>
                  <!-- Phone -->
                  <a [href]="'tel:' + row.phone" class="item-phone text-reset">{{ row.phone }}</a>
                </td>
                <td>
                  <!-- Badge -->
                  <span class="item-score badge bg-danger-soft">{{ row.leadScore }}</span>
                </td>
                <td>
                  <!-- Link -->
                  <a class="item-company text-reset" routerLink="">{{ row.company }}</a>
                </td>
                <td class="text-end">
                  <!-- Dropdown -->
                  <div class="dropdown">
                    <a aria-expanded="false" aria-haspopup="true" class="dropdown-ellipses dropdown-toggle"
                      data-bs-toggle="dropdown" href="#" role="button">
                      <i class="fe fe-more-vertical"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-end">
                      <a class="dropdown-item" href="#!">
                        Action
                      </a>
                      <a class="dropdown-item" href="#!">
                        Another action
                      </a>
                      <a class="dropdown-item" href="#!">
                        Something else here
                      </a>
                    </div>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div [class.visually-hidden]="searchTableViewModel.state === 'LOADED'" class="card-body text-center">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Chargement...</span>
        </div>
      </div>
      <div class="card-footer">
        <app-search-table-footer [searchTableViewModel]="searchTableViewModel" nextPageText="Page suivante"
        previousPageText="Page précédente"></app-search-table-footer>
      </div>
    </div>

  </div>
</div>
